import type { HandleActionType } from './types';

export const actionLabels: Record<HandleActionType, string> = {
  hangup: 'Hang Up',
  zero: 'Route to Zero',
  officeClosed: 'Route to Office Closed',
};
